module.exports = __webpack_public_path__ + "static/media/arrived_cluster.e44a41a2.svg";